import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const ACCENT = {
  pink: { bg: "bg-[#ff1493]", text: "text-white", chip: "bg-black text-[#ff1493]" },
  blue: { bg: "bg-[#00d4ff]", text: "text-black", chip: "bg-black text-[#00d4ff]" },
  yellow: { bg: "bg-[#facc15]", text: "text-black", chip: "bg-black text-[#facc15]" },
  dark: { bg: "bg-black", text: "text-white", chip: "bg-[#ff1493] text-white" },
};

export default function OffersStrip() {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    api.get("/offers").then((r) => setOffers(r.data)).catch(() => setOffers([]));
  }, []);

  if (offers.length === 0) return null;

  return (
    <section className="border-b-[3px] border-black">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="font-mono-ui text-xs text-[#ff1493] flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5" strokeWidth={2.5} /> SPECIAL OFFERS
            </div>
            <h2 className="font-display text-4xl md:text-5xl leading-none mt-2">This week&apos;s deals</h2>
          </div>
          <div className="font-mono-ui text-[11px] text-black/60">LIMITED STOCK · WHILE SUPPLIES LAST</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {offers.map((o) => {
            const accent = ACCENT[o.accent] || ACCENT.pink;
            const href = o.product_id ? `/product/${o.product_id}` : o.href || "/shop";
            return (
              <Link
                key={o.id}
                to={href}
                data-testid={`offer-${o.id}`}
                className="group relative border-[3px] border-black shadow-brut btn-press overflow-hidden min-h-[260px] flex flex-col"
              >
                {o.bg_image_url && (
                  <>
                    <img
                      src={o.bg_image_url}
                      alt={o.title}
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/55 transition-colors" />
                  </>
                )}
                <div className="relative flex-1 flex flex-col justify-between p-5 text-white">
                  <div className={`inline-flex items-center gap-1 px-2 py-1 border-[2px] border-black ${accent.chip} font-mono-ui text-[10px] font-bold self-start`}>
                    <Sparkles className="w-3 h-3" strokeWidth={2.5} /> OFFER
                  </div>
                  <div>
                    <div className="font-display text-2xl md:text-3xl leading-none">{o.title}</div>
                    {o.subtitle && (
                      <p className="mt-3 text-sm leading-relaxed max-w-[280px] drop-shadow">
                        {o.subtitle}
                      </p>
                    )}
                    <span className={`mt-5 inline-flex items-center gap-2 ${accent.bg} ${accent.text} border-[3px] border-black px-4 py-2 shadow-brut-sm font-mono-ui text-xs font-bold`}>
                      {o.cta_label} <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
